import { Tag, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import Private from "../../Components/Private"

import "./EnrollmentDescriptorCard.less"

const { Text } = Typography

const EnrollmentArnCodesCard = ({ enrollment, theme }) => {
  const { t } = useTranslation()

  return (
    <div
      className={cls("enrollment-descriptors-status-card", {
        "enrollment-descriptors-status-card_arn": true,
        "enrollment-descriptors-status-card_admin": true
      })}
    >
      <div className={"enrollment-descriptors-status-card-header"}>
        <Text type="secondary">{t("ARN codes")}</Text>
      </div>
      <div
        className={cls("enrollment-descriptors-status-card-body", {
          empty: !enrollment["is_active"]
        })}
      >
        {enrollment["is_active"] ? (
          enrollment?.["visa_arn_codes"]?.map((arn) => {
            return (
              <Tag
                key={arn}
                bordered={theme === "dark"}
                color="processing"
                style={{
                  fontSize: 14,
                  borderRadius: 14,
                  padding: "4px 8px",
                  margin: "5px 0",
                  color: "#1448CB",
                  background: theme === "dark" ? "none" : "#F2F6FF",
                  width: "fit-content"
                }}
              >
                <Text copyable={{ tooltips: false, text: arn }} style={{ marginRight: 4 }} />
                <Private>{arn}</Private>
              </Tag>
            )
          })
        ) : (
          <>
            <Text type="secondary" strong>
              {t("No enrollments connected yet")}
            </Text>
            <Text
              type="secondary"
              style={{
                textAlign: "center",
                display: "inline-block",
                maxWidth: 202
              }}
            >
              {t("If you wish to use _enrollment_, add one or more enrollments.", {
                enrollment: enrollment.name
              })}
            </Text>
          </>
        )}
      </div>
    </div>
  )
}
export default EnrollmentArnCodesCard
